export default __webpack_public_path__ + "static/media/pageseven.9346d739.txt";